import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    variant: "secondary",
    css: css`
        padding: 10px 34px;
        margin-left: 10px;
        background: ${getColor("primary.contrast")};
        color: ${getColor("text.accent")};
        border: 2px solid ${getColor("text.accent")};
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
    `,
    hoverMode: "none",
};
customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        padding: 10px 34px;
        span[class^="TypographyStyle"] {
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            > div {
                margin-top: 0 !important;
            }
        `,
    },
};
